import type { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

import { Label } from '../label/label';

import styles from './field_label.module.css';

type FieldLabelProps = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    isRequired?: boolean;
    tooltip?: ReactNode;
    className?: string;
  }>;

/** Label for a form field, with optional tooltip and required indicator. */
export function FieldLabel({
  children,
  isRequired,
  tooltip,
  className,
  ...rest
}: FieldLabelProps) {
  return (
    <div {...rest} className={styles.label_tooltip_wrapper}>
      <Label className={className} isRequired={isRequired}>
        {children}
      </Label>
      {tooltip}
    </div>
  );
}
